<a class="full-height link" [routerLink]="'/' + link" *ngIf="link; else noLink">
  <ng-container *ngTemplateOutlet="template; context: templateContext"></ng-container>
</a>
<ng-template #noLink>
  <ng-container *ngTemplateOutlet="template; context: templateContext"></ng-container>
</ng-template>
